@if (!bvTextLink) {
  <button
    id="btn_subrequired"
    class="rounded-md bg-orange-600 px-3 py-2 text-md font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
    (click)="gotoSub()"
    >
    {{ "FEATURE_REQUIRES_PAID_PLAN" | translate }}
  </button>
}
@if (bvTextLink) {
  <a
    (click)="gotoSub()"
    class="cursor-pointer text-bv-darkblue-A300 hover:text-bv-darkblue-A700"
    >
    {{ "FEATURE_REQUIRES_PAID_PLAN" | translate }}
  </a>
}
